import { createRouter, createWebHistory } from "vue-router";
import clientRouter from "@/route/clientRouter";
import adminRouter from "@/route/adminRouter";
import axios from "axios";
import { useCookies } from "vue3-cookies";

const routes = [
  ...clientRouter,
  ...adminRouter,
  {
    path    : "/:pathMatch(.*)*",
    meta    : { authRequired: false },
    redirect: "/main"
  }
];

const router = createRouter({
  history             : createWebHistory(),
  routes,
  linkActiveClass     : "selected",
  linkExactActiveClass: "selected"
});

const { cookies } = useCookies();
const interceptor = {
  refreshTokenCheck: async function() {
    const refreshToken = cookies.get("Refresh");
    return await axios.post("/api/auth/checkJwtRefresh", {}, {
      headers: { Authorization: `Bearer ${refreshToken}` }
    }).then(function(response) {
      if (response.data.success === 200) {
        cookies.set("Authentication", response.data.resp.accessToken, 60 * 20);
        return true;
      }
      return false;
    }).catch(function(err) {
      console.error(err);
      return false;
    });
  },
  tokenCheck       : async function() {
    const clientToken = cookies.get("Authentication");
    if (!clientToken && !(await this.refreshTokenCheck())) {
      return false;
    }

    return await axios.post("/api/auth/jwtCheck", "", {
      headers: { Authorization: `Bearer ${clientToken}` }
    }).then(function(response) {
      return response.data.success === 200;
    }).catch(function(err) {
      console.error(err);
      return false;
    });
  }
};

router.beforeEach(async (to, from, next) => {
  if (to.matched[0].meta.authRequired) {
    const isAuth = await interceptor.tokenCheck();
    if (!isAuth)
      return next("/admin/login");
  }
  next();
});

export default router;
